import React from "react";
import { useParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { AnswersList } from "./answersList";

export const AnswersListPage = () => {
  const { id } = useParams();

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Answers List" />
      <AnswersList questionId={Number(id)} />
    </DashboardLayout>
  );
}; 